var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 13,
    viewBox: "0 0 11 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.27314 6.12185C4.61277 6.12185 4.07247 5.58155 4.07247 4.92118C4.07247 4.26081 4.61277 3.72051 5.27314 3.72051C5.93351 3.72051 6.47381 4.26081 6.47381 4.92118C6.47381 5.58155 5.93351 6.12185 5.27314 6.12185ZM8.87515 5.04124C8.87515 2.86203 7.28426 1.31917 5.27314 1.31917C3.26202 1.31917 1.67113 2.86203 1.67113 5.04124C1.67113 6.44603 2.84178 8.30707 5.27314 10.5283C7.70449 8.30707 8.87515 6.44603 8.87515 5.04124ZM5.27314 0.1185C7.79454 0.1185 10.0758 2.05158 10.0758 5.04124C10.0758 7.03436 8.47292 9.39367 5.27314 12.1252C2.07335 9.39367 0.470459 7.03436 0.470459 5.04124C0.470459 2.05158 2.75173 0.1185 5.27314 0.1185Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaps);
export default __webpack_public_path__ + "static/media/maps.592985e48d53bb98b63192b21aa5833e.svg";
export { ForwardRef as ReactComponent };